import React from "react";
import { useNavigate } from 'react-router-dom';
import styles from "./ConditionsUtilisationPage.module.scss"; // Make sure to have a corresponding SCSS file

import Footer from '../../components/Footer/Footer';

const ConditionsUtilisationPage_En = () => {

  const navigate = useNavigate();

  return (
    <>
      <div className={styles.container}>
        <div className={styles.content}>
            <h1>Terms of service</h1>

            <hr />
            <section>
            <h2>1. Service overview</h2>
            <p>
                The application <strong>Hatann'App</strong> is an interactive treasure hunt platform that allows users
                to answer questions based on their progress along a predefined route.
                Using the application implies full and complete acceptance of these terms of service.
            </p>
            </section>

            <section>
            <h2>2. Access to the service</h2>
            <p>
                The application <strong>Hatann'App</strong> is accessible via a web browser on a smartphone or any other compatible device.
                Access may be limited in case of connection loss, but the application is designed to ensure an optimal experience even in offline mode.
            </p>
            </section>

            <section>
            <h2>3. Account creation</h2>
            <p>
                Some features of <strong>Hatann'App</strong> may require the creation of a user account.
                By registering, the user agrees to provide accurate information and to maintain the confidentiality of their credentials.
            </p>
            </section>

            <section>
            <h2>4. Use of the service</h2>
            <p>The user agrees to:</p>
            <ul>
                <li>Not use <strong>Hatann'App</strong> for fraudulent or illegal purposes.</li>
                <li>Not disrupt the proper functioning of the service.</li>
                <li>Respect other participants in the treasure hunt.</li>
            </ul>
            </section>

            <section>
            <h2>5. Intellectual property</h2>
            <p>
                All elements of the application <strong>Hatann'App</strong>, including content, images, and code, are protected by intellectual property laws
                and may not be reproduced, modified, or distributed without prior authorization.
            </p>
            </section>

            <section>
            <h2>6. Personal data protection</h2>
            <p>
                <strong>Hatann'App</strong> collects certain data to improve the user experience. This data is processed
                in accordance with our <a className={styles.link} onClick={() => navigate("/privacy")} rel="noopener noreferrer">privacy policy</a>.
            </p>
            </section>

            <section>
            <h2>7. Liability</h2>
            <p>
                The publisher of <strong>Hatann'App</strong> cannot be held responsible in case of:
            </p>
            <ul>
                <li>Misuse of the service by the user.</li>
                <li>Technical issues beyond our control (server failure, connection loss, etc.).</li>
                <li>Content generated by users themselves.</li>
            </ul>
            </section>

            <section>
            <h2>8. Changes to the terms</h2>
            <p>
                The publisher reserves the right to modify these terms of service at any time.
                Users will be informed of updates via <strong>Hatann'App</strong>.
            </p>
            </section>

            <section>
            <h2>9. Contact</h2>
            <p>
                For any questions regarding these terms, you can contact us at the following address:&nbsp; 
                <a className={styles.link} href="mailto:contact@hatanna-editions.fr">contact@hatanna-editions.fr</a>
            </p>
            </section>

            <section>
            <h2>10. Development</h2>
            <p>
                This application was developed by <strong>Scriptales SAS</strong> (<a className={styles.link} href="https://scriptales.fr" target="_blank" rel="noopener noreferrer">scriptales.fr</a>).
            </p>
            </section>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ConditionsUtilisationPage_En;
